module.exports = __webpack_public_path__ + "static/media/coming-banner.42f2e401.jpg";